import { connectMediaStore } from './withOwnReduxStore';
import { setCurrentSubfolderId, unsetCurrentSubfolderId } from '../actions';
import { getCurrentSubfolderId, getCurrentSubfolder } from '../selectors';
export default connectMediaStore(function (state) { return ({
    currentSubfolderId: getCurrentSubfolderId(state),
    currentSubfolder: getCurrentSubfolder(state),
}); }, {
    setCurrentSubfolderId: setCurrentSubfolderId,
    unsetCurrentSubfolderId: unsetCurrentSubfolderId,
});
//# sourceMappingURL=withCurrentSubfolder.js.map